import { render, staticRenderFns } from "./pictureCenterMobile.vue?vue&type=template&id=2b662a12&scoped=true&"
import script from "./pictureCenterMobile.vue?vue&type=script&lang=js&"
export * from "./pictureCenterMobile.vue?vue&type=script&lang=js&"
import style0 from "./pictureCenterMobile.vue?vue&type=style&index=0&id=2b662a12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b662a12",
  null
  
)

export default component.exports